import moment from 'moment'

export default {
    methods: {
        gFormatDate(date, format = 'DD/MM/YYYY') {
            return moment(date).format(format)
        },
    }
}